import { createContext, useContext } from 'react'

const googleMapsInitial = {
  googleMapsScriptLoading: true,
  // eslint-disable-next-line
  setGoogleMapsScriptLoading: (googleMapsScriptLoading: boolean) => {},
}

const GoogleMapsContext = createContext(googleMapsInitial)

export const useGoogleMapsContext = (): typeof googleMapsInitial => {
  const context = useContext(GoogleMapsContext)

  if (!context) {
    throw new Error(
      'useGoogleMapsContext must be used within a GoogleMapsContext'
    )
  }

  return context
}

export default GoogleMapsContext
